import React, { useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useEnvironment } from '../context/EnvironmentContext';
import { Environment } from '../types/MainContextType';
import { getApiEndpoints } from '../config/apiConfig';
import { ProgressSpinner } from 'primereact/progressspinner';

type EnvironmentOption = {
  label: string;
  value: Environment;
  color: string;
};

const environments: EnvironmentOption[] = [
  { label: 'Development', value: 'development', color: '#4caf50' },
  { label: 'Staging', value: 'staging', color: '#ff9800' },
  { label: 'Production', value: 'production', color: '#f44336' }
];

export const EnvironmentDropdown: React.FC = () => {
  const { currentEnvironment, setCurrentEnvironment, isChangingEnvironment } = useEnvironment();
  
  // Log the API endpoints when the environment changes
  useEffect(() => {
    const apiEndpoints = getApiEndpoints(currentEnvironment);
    console.info(`Environment changed to: ${currentEnvironment}`);
    console.info(`Idwal API: ${apiEndpoints.idwalApi}`);
    console.info(`Orchestration API: ${apiEndpoints.orchestrationApi}`);
  }, [currentEnvironment]);
  
  const itemTemplate = (option: EnvironmentOption) => {
    return (
      <div className="flex align-items-center">
        <div 
          className="mr-2" 
          style={{ 
            width: '12px', 
            height: '12px', 
            borderRadius: '50%', 
            backgroundColor: option.color 
          }}
        />
        <span>{option.label}</span>
      </div>
    );
  };

  const valueTemplate = (option: string) => {
    // Find the currently selected environment object
    const selectedEnv = getSelectedEnvironment();
    return (
      <div className="flex align-items-center">
        {isChangingEnvironment ? (
          <ProgressSpinner style={{ width: '16px', height: '16px', marginRight: '8px' }} />
        ) : (
          <div 
            className="mr-2" 
            style={{ 
              width: '10px', 
              height: '10px', 
              borderRadius: '50%', 
              backgroundColor: "white"
            }}
          />
        )}
        <span style={{ color: 'white', fontWeight: 500 }}>{selectedEnv.label}</span>
      </div>
    );
  };

  // Get the currently selected environment
  const getSelectedEnvironment = () => {
    return environments.find(env => env.value === currentEnvironment) || environments[0];
  };

  return (
    <div className="environment-dropdown">
      <Dropdown
        value={currentEnvironment}
        options={environments}
        onChange={(e) => setCurrentEnvironment(e.value)}
        className="p-dropdown-sm"
        style={{ 
          minWidth: '160px',
          borderRadius: '6px',
          backgroundColor: getSelectedEnvironment().color,
          border: 'none',
          marginRight: '12px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
        }}
        optionLabel="label"
        optionValue="value"
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        showClear={false}
        disabled={isChangingEnvironment}
      />
    </div>
  );
};